import Analytics from '../Analytics.esm.js';
import GTM from '../provider/GTM.esm.js';

const analytics = new Analytics();
const getAnalytics = ()=>{
    if (!analytics.isPrepared) {
        const providers = [];
        if (process.env.NEXT_PUBLIC_ANALYTICS_GTM_ID) {
            providers.push(new GTM(process.env.NEXT_PUBLIC_ANALYTICS_GTM_ID, process.env.NEXT_PUBLIC_ANALYTICS_GTM_AUTH || '', 'env-5', 'x', 'dataLayer', {}, {}));
        }
        analytics.prepare(providers);
    }
    return analytics;
};

export { getAnalytics as default };
